import { api } from "@/lib/http.ts";
import type {
  MeetingPreferenceCreateReq,
  MeetingPreferenceListResp,
  MeetingPreferenceResp,
  MeetingPreferenceUpdateReq,
} from "@/types/meetingPreferences.ts";

const BASE_API_PATH = "/api/a/meeting-preferences";

export const getMeetingPreferences = async (): Promise<MeetingPreferenceListResp> => {
  return api.get<MeetingPreferenceListResp>(BASE_API_PATH).then((res) => res.data);
};

export const createMeetingPreference = async (
  data: MeetingPreferenceCreateReq,
): Promise<MeetingPreferenceResp> => {
  const response = await api.post<MeetingPreferenceResp>(BASE_API_PATH, data);
  return response.data;
};

export const updateMeetingPreference = async (
  id: string,
  data: MeetingPreferenceUpdateReq,
): Promise<MeetingPreferenceResp> => {
  const response = await api.post<MeetingPreferenceResp>(`${BASE_API_PATH}/${id}`, data);
  return response.data;
};

export const deleteMeetingPreference = async (id: string) => {
  return api.post(`${BASE_API_PATH}/${id}/delete`);
};
